import { Component, createRef } from "preact";
import { isMobileOnly } from "react-device-detect";
import IconCalendar from "../../../../common/components/icons/IconCalendar";
import IconCaretDown from "../../../../common/components/icons/IconCaretDown";
import { connectWithTranslations } from "../../../../common/helpers/translationsHelpers";
import { GA4EVENT, TIME_FILTERS_VALUES } from "../../../constants";

class AdvancedTimeFilter extends Component {
    container = createRef();
    constructor(props) {
        super(props);

        this.renderTitle = this.renderTitle.bind(this);
        this.renderOption = this.renderOption.bind(this);
        this.onOptionSelected = this.onOptionSelected.bind(this);
        this.togglePicker = this.togglePicker.bind(this);
        this.state = {
            isPickerOpen: false,
            timeOption: null,
        };
    }
    componentWillMount() {
        this.setState({ timeOption: this.props.time });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ timeOption: nextProps.time });
    }

    onOptionSelected(option) {
        if (isMobileOnly) this.setState({ timeOption: option });
        else {
            this.setState({ timeOption: option });
            this.props.onTimeFilterChanged(option);
            this.togglePicker();
        }
    }

    apply() {
        this.props.onTimeFilterChanged(this.state.timeOption);
        this.togglePicker();
    }

    togglePicker() {
        if (this.state.isPickerOpen) {
            this.setState({ isPickerOpen: false, timeOption: this.props.time });
            document.removeEventListener("click", this.handleOutsideClick, false);
        } else {
            this.setState({ isPickerOpen: true });
            document.addEventListener("click", this.handleOutsideClick, false);
        }
    }
    handleOutsideClick = (e) => {
        let currentPicker = this.container;
        if (currentPicker.current != null) {
            try {
                let timeFilterContainer = e.path?.indexOf(currentPicker.current) !== -1;
                if (!timeFilterContainer) {
                    this.togglePicker();
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    renderTitle(selectedOption, isOpen, upButton, downButton) {
        return (
            <span>
                <span class="fxs_inner">{this.props.translate(selectedOption)}</span>
                {isOpen ? upButton : downButton}
            </span>
        );
    }

    renderOption(option) {
        return <span>{this.props.translate(option)}</span>;
    }

    render({ time, translate, showHighlighted = true }) {
        const values = Object.values(TIME_FILTERS_VALUES).filter(
            (x) => x !== TIME_FILTERS_VALUES.Custom
        );

        const selected = values.find((x) => x === time);

        return (
            <div class="fxs_c_time-filters" ref={this.container}>
                <button
                    type="button"
                    onClick={this.togglePicker}
                    class="fxs_btn fxs_btn_xsmall fxs_btn_phantom"
                >
                    <IconCalendar /> <IconCaretDown />{" "}
                    <span>{translate(this.state.timeOption)}</span>
                </button>
                <div class="fxs_clearfix"></div>
                {this.state.isPickerOpen && isMobileOnly && (
                    <div class="fxs_c_advanced-countries-backdrop"></div>
                )}
                {this.state.isPickerOpen && (
                    <div
                        class={`${
                            isMobileOnly
                                ? "fxs_c_filters_picker"
                                : "fxs_c_time_filter_dropdown"
                        }`}
                    >
                        <p class="fxs_c_time_filter_disclaimer">
                            {translate("AdvancedTimeFilter_Description")}
                        </p>
                        <h4 class="fxs_c_time_filter_title">
                            {translate("AdvancedTimeFilter_Selector")}
                        </h4>
                        <form>
                            {values.map((value) => (
                                <div>
                                    <input
                                        type="radio"
                                        name="dateTimeOption"
                                        data-gtmid={this.props.getDropdownOptionGtmId(
                                            value
                                        )}
                                        data-ga4event-clk-name={this.props.getGa4Name}
                                        data-ga4event-element={this.props.getDropdownOptionGa4Id(
                                            value
                                        )}
                                        onClick={() => this.onOptionSelected(value)}
                                        checked={
                                            showHighlighted &&
                                            this.state.timeOption === value
                                        }
                                        id={value}
                                    />
                                    <span
                                        onClick={() => this.onOptionSelected(value)}
                                        class="fxs_c_time_filter_item"
                                    >
                                        {translate(value)}
                                    </span>
                                </div>
                            ))}
                        </form>
                        {isMobileOnly && (
                            <div class="fxs_c_time_filter_footer">
                                <button
                                    type="button"
                                    onClick={() => this.togglePicker()}
                                    class="fxs_btn fxs_btn_phantom  fxs_fLeft"
                                >
                                    {" "}
                                    {this.props.translate("Cancel")}
                                    {"Cancel"}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => this.apply()}
                                    class="fxs_btn fxs_btn_cta   fxs_fRight"
                                >
                                    {" "}
                                    {this.props.translate("Done")}
                                    {"Done"}
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default connectWithTranslations()(AdvancedTimeFilter);
